const API_ERROR_EVENT = 'mpower:api-error'

export type ApiErrorEventDetail = {
  message: string
}

export function emitApiError(message: string) {
  if (typeof window === 'undefined' || !message?.trim()) {
    return
  }

  window.dispatchEvent(
    new CustomEvent<ApiErrorEventDetail>(API_ERROR_EVENT, {
      detail: { message: message.trim() },
    }),
  )
}

export function subscribeApiError(listener: (message: string) => void) {
  if (typeof window === 'undefined') {
    return () => undefined
  }

  const handler = (event: Event) => {
    const message = (event as CustomEvent<ApiErrorEventDetail>).detail?.message
    if (message) {
      listener(message)
    }
  }

  window.addEventListener(API_ERROR_EVENT, handler)
  return () => window.removeEventListener(API_ERROR_EVENT, handler)
}
